import React, { useEffect, useState } from "react";
import Navbar from "../../../components/Navbar/Navbar";
import Footer from "../../../components/Footer/Footer";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import styles from "./LandlordOnboard.module.css";
import { FormControl, InputLabel, MenuItem, Select, Chip } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { toast } from "react-toastify";
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import {
  eighteenYearsAgo,
  isValidEmail,
  isValidPhone,
  sendEmailVerification,
  validatePassword,
  verifyAndFetchUserRoles,
} from "../../../util/utilFunctions";
import dayjs from "dayjs";
import axios from "axios";
import { useAuth } from "../../../contexts/AuthContext";
import { useNavigate } from "react-router-dom";

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

import { styled } from "@mui/material/styles";
import { useUtil } from "../../../contexts/UtilContext";

// Styled components for centering modal elements
const CenteredDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialog-paper": {
    textAlign: "center",
  },
}));

const CenteredDialogTitle = styled(DialogTitle)({
  textAlign: "center",
});

const CenteredDialogContent = styled(DialogContent)({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
});

const CenteredDialogActions = styled(DialogActions)({
  justifyContent: "center",
  padding: "16px",
});

const LandlordOnboard = () => {
  const { loginUser, userDetails } = useAuth();
  const { showLoader, hideLoader } = useUtil();
  const navigate = useNavigate();

  const [step, setStep] = useState(1);
  const [formError, setFormError] = useState("");
  const [openExistingUserModal, setOpenExistingUserModal] = useState(false);
  const [timer, setTimer] = useState(0);
  const [showResendButton, setShowResendButton] = useState(false);
  const [emailDetails, setEmailDetails] = useState({
    email: "",
  });
  const [basicDetails, setBasicDetails] = useState({
    firstName: "",
    middleName: "",
    lastName: "",
    screenName: "",
    // photo: null,
    // email: "",
    phoneNumber: "",
    dateOfBirth: "",
    gender: "",
    state: "",
    bio: "",
  });

  const [passwordDetails, setPasswordDetails] = useState({
    password: "",
    confirmPassword: "",
  });

  const [verificationDetails, setVerificationDetails] = useState({
    verificationCode: "",
  });

  const handleExistingUserModalClose = () => {
    setOpenExistingUserModal(false);
  };

  const handleLoginRedirect = () => {
    // Redirect to login page
    // @TODO
     toast.success("create a landlord account with existing details");
    // cloase the model
    setOpenExistingUserModal(false);

    // make API call
    handleExistingUserRegistration();
  };

  const startTimer = () => {
    setTimer(60);
    setShowResendButton(false);
  };

  // Note: Related to specialization
  const [open, setOpen] = useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const handleEmailChange = (e) => {
    const { name, value } = e.target;
    setEmailDetails({ ...emailDetails, [name]: value });
  };

  const handleBasicChange = (e) => {
    const { name, value } = e.target;
    setBasicDetails({ ...basicDetails, [name]: value });
  };

  const handlePasswordChange = (e) => {
    const { name, value } = e.target;
    setPasswordDetails({ ...passwordDetails, [name]: value });
  };

  const handleVerificationChange = (e) => {
    const { name, value } = e.target;
    setVerificationDetails({ ...verificationDetails, [name]: value });
  };

  const handleNext = async (e) => {
    e.preventDefault();

    // do front-end validation and then proceed
    if (step === 1) {
      // validate email details
      if (validateEmailDetails()) {
        // make API call to verify if the user has already registerd as user
        // also get his role
        // alert("API here");
        var response = await verifyAndFetchUserRoles(emailDetails.email);
        // console.log("user role checl res: ", response);
        if (
          response.status === 200 &&
          response.data &&
          "success" in response.data
        ) {
          // console.log("inside api response");
          if (response.data.existingUser) {
            // further check roles
            if (response.data.isLandlord) {
              // already a landlord
              toast.error("redirect to login");
              // login the user
              loginUser(
                response.data.accessToken ? response.data.accessToken : "",
                response.data.user
                  ? {
                      id: response.data.user.id,
                      email: response.data.user.email,
                      firstName: response.data.user.first_name,
                      lastName: response.data.user.last_name,
                      photoUrl: response.data.user.photo_url,
                    }
                  : {}
              );
              // redirect to dashboard
              navigate(`/MyFirstLand?category=listings`);
            } else {
              // existing user, but not a landlord
              // autofill details
              // skip steps and go to additional details step
              // since there are no additional details here, proceed to create landlord
              // show a modal and ask for confirmation
              setOpenExistingUserModal(true);
            }
          } else {
            // new user
            // proceed without any changes
            setStep(step + 1);
          }
        } else {
          // some error occurred while sending email verification
          setFormError(
            "Some error occurred while sending verification email. Please try again!"
          );
        }
      }
    } else if (step === 2) {
      // validate basic details
      if (validateBasicDetails()) {
        setStep(step + 1);
      } else {
        // do nothing
      }
    } else if (step === 3) {
      // validate password details
      if (validatePasswordDetails()) {
        // make API call to send verification code to email
        var response = await sendEmailVerification(emailDetails.email);
        // console.log("response: ", response);
        if (
          response.status === 200 &&
          response.data &&
          "success" in response.data
        ) {
          // console.log("inside api response");
          // means that verification code has been successfully sent
          setStep(step + 1);
          startTimer(); // Start the timer when moving to step 3
        } else {
          // some error occurred while sending email verification
          setFormError(
            "Some error occurred while sending verification email. Please try again!"
          );
        }
      } else {
        // do nothing
      }
    }
  };

  const handleBack = () => {
    setStep(step - 1);
  };

  const handleSubmit = async () => {
    // console.log("q!!!!");
    // validate professional details
    if (!validateVerificationDetails()) {
      return;
    }

    // Process the form data
    // console.log("Email Details:", emailDetails);
    // console.log("Basic Details:", basicDetails);
    // console.log("Password Details:", passwordDetails);
    // console.log("Verification Details:", verificationDetails);
    // Submit the form data to the server or handle it accordingly

    try {
      showLoader();

      const requestData = {
        emailDetails: emailDetails,
        basicDetails: {
          ...basicDetails,
          dateOfBirth: basicDetails.dateOfBirth.format("YYYY-MM-DD"),
        },
        passwordDetails: passwordDetails,
        verificationDetails: verificationDetails,
      };

      const response = await axios.post(
        `${import.meta.env.VITE_BACKEND_URL}/landlord/register`,
        requestData,
        {
          headers: {
            // Authorization: accessToken,
          },
        }
      );

      // console.log("response: ", response);

      // @TODO: after getting the response
      // if success, then redirect to dashboard
      // if success, save the accessToken
      // send a url param to show first time register message

      if (response.status === 200) {
        if (response.data && "success" in response.data) {
          // response data exists
          if (response.data.success) {
            // signup successful
            // console.log("Registration successful");
            // console.log("response: ", response);

            // auth context function
            loginUser(
              response.data.accessToken ? response.data.accessToken : "",
              response.data.user
                ? {
                    id: response.data.user.id,
                    email: response.data.user.email,
                    firstName: response.data.user.first_name,
                    lastName: response.data.user.last_name,
                    photoUrl: response.data.user.photo_url,
                  }
                : {}
            );

            // navigate to landlord listings page
            navigate(`/MyFirstLand?category=listings&newLandlord=true`);
          } else {
            // some error in creating the user
            var errorMsg = response.data.message
              ? response.data.message
              : "Some error occurred while creating the landlord!";

            setFormError(errorMsg);
          }
        } else {
          // console.log("API response data error!");
          var errorMsg = "Some error occurred while creating the landlord!";

          setFormError(errorMsg);
        }
      } else {
        var errorLog = response.data.error
          ? response.data.error
          : "Unable to get backend error!";
        var errorMsg = response.data.message
          ? response.data.message
          : "Some error occurred while trying to create the landlord!";
        // console.log("Registration failed: ", errorLog);
        setFormError(errorMsg);
      }
    } catch (error) {
      // console.log("Registration failed: ", error);
      var errorLog = response.data.error
        ? response.data.error
        : "Unable to get backend error!";
      var errorMsg = response.data.message
        ? response.data.message
        : "Some error occurred while trying to create the landlord!";
      // console.log("Registration failed: ", errorLog);
      console.error("Error: ", error);
      setFormError(errorMsg);
      // setFormError(
      //   "Some error occurred while registring the landlord. Please try agaoin later!"
      // );
    } finally {
      hideLoader();
    }
  };

  const handleExistingUserRegistration = async () => {
    // validate email details
    if (!validateEmailDetails()) {
      return;
    }

    // console.log("Email Details:", emailDetails);

    try {
      showLoader();

      const requestData = {
        emailDetails: emailDetails,
      };

      const response = await axios.post(
        `${import.meta.env.VITE_BACKEND_URL}/landlord/existing-register`,
        requestData,
        {
          headers: {
            // Authorization: accessToken,
          },
        }
      );

      // console.log("response: ", response);

      // if success, then redirect to dashboard
      // if success, save the accessToken
      // send a url param to show first time register message

      if (response.status === 200) {
        if (response.data && "success" in response.data) {
          // response data exists
          if (response.data.success) {
            // signup successful
            // console.log("Registration successful");
            // console.log("response: ", response);

            // auth context function
            loginUser(
              response.data.accessToken ? response.data.accessToken : "",
              response.data.user
                ? {
                    id: response.data.user.id,
                    email: response.data.user.email,
                    firstName: response.data.user.first_name,
                    lastName: response.data.user.last_name,
                    photoUrl: response.data.user.photo_url,
                  }
                : {}
            );

            // navigate to landlord listings page
            navigate(`/MyFirstLand?category=listings&newLandlord=true`);
          } else {
            // some error in creating the user
            var errorMsg = response.data.message
              ? response.data.message
              : "Some error occurred while creating the landlord!";

            setFormError(errorMsg);
          }
        } else {
          // console.log("API response data error!");
          var errorMsg = "Some error occurred while creating the landlord!";

          setFormError(errorMsg);
        }
      } else {
        var errorLog = response.data.error
          ? response.data.error
          : "Unable to get backend error!";
        var errorMsg = response.data.message
          ? response.data.message
          : "Some error occurred while trying to create the landlord!";
        // console.log("Registration failed: ", errorLog);
        setFormError(errorMsg);
      }
    } catch (error) {
      // console.log("Registration failed: ", error);
      var errorLog = response.data.error
        ? response.data.error
        : "Unable to get backend error!";
      var errorMsg = response.data.message
        ? response.data.message
        : "Some error occurred while trying to create the landlord!";
      // console.log("Registration failed: ", errorLog);
      console.error("Error: ", error);
      setFormError(errorMsg);
    } finally {
      hideLoader();
    }
  };

  // const handleDOBChange = (date) => {
  //   setBasicDetails({
  //     ...basicDetails,
  //     dateOfBirth: date ? dayjs(date).format("YYYY-MM-DD") : "",
  //   });
  // };

  const handleDOBChange = (value) => {
    setBasicDetails((prev) => ({
      ...prev,
      dateOfBirth: value, // Store as a dayjs object
    }));
  };

  const validateEmailDetails = () => {
    setFormError("");

    if (!emailDetails.email) {
      setFormError("Please provide your Email");
      return false;
    }

    // email checker
    if (!isValidEmail(emailDetails.email)) {
      setFormError("Please provide a valid Email format");
      return false;
    }

    return true;
  };

  const validateBasicDetails = () => {
    setFormError("");

    if (!basicDetails.firstName) {
      setFormError("Please provide your First Name");
      return false;
    }

    if (!basicDetails.lastName) {
      setFormError("Please provide your Last Name");
      return false;
    }

    if (basicDetails.phoneNumber && !isValidPhone(basicDetails.phoneNumber)) {
      setFormError("Please provide a valid Phone Number");
      return false;
    }

    if (basicDetails.screenName && basicDetails.screenName.length > 12) {
      setFormError("Screen Name should not exceed 12 characters");
      return false;
    }

    // Date of Birth validation
    if (!basicDetails.dateOfBirth) {
      setFormError("Please provide your Date of Birth");
      return false;
    }

    // const dob = dayjs(basicDetails.dateOfBirth);
    // const age = dayjs().diff(dob, "year");
    const dob = dayjs(basicDetails.dateOfBirth.slice(0, 10));
    const age = dayjs().diff(dob, "year");

    if (age < 18) {
      setFormError("You must be at least 18 years old");
      return false;
    }

    // passed all validations
    return true;
  };

  const validatePasswordDetails = () => {
    setFormError("");

    if (!passwordDetails.password) {
      setFormError("Please provide a Password");
      return false;
    }

    if (!validatePassword(passwordDetails.password)) {
      setFormError(
        "Password must be at least 8 characters long, include an uppercase letter, a lowercase letter, a number, and a special character."
      );
      return false;
    }

    if (!passwordDetails.confirmPassword) {
      setFormError("Please confirm the Password");
      return false;
    }

    if (passwordDetails.password != passwordDetails.confirmPassword) {
      setFormError("Passwords should match");
      return false;
    }
    // console.log(passwordDetails);

    // passed all validations
    return true;
  };

  const validateVerificationDetails = () => {
    setFormError("");

    // Validate languages
    if (!verificationDetails.verificationCode) {
      setFormError("Please provide the verification code.");
      return false;
    }

    // if any other special requirement are needed

    return true;
  };

  const handleResendCode = async () => {
    try {
      const response = await sendEmailVerification(emailDetails.email);
      if (
        response.status === 200 &&
        response.data &&
        "success" in response.data
      ) {
        startTimer();
        // Optionally, show a success message to the user
        // console.log("Verification code resent successfully");
      } else {
        setFormError("Failed to resend verification code. Please try again.");
      }
    } catch (error) {
      console.error("Error resending verification code:", error);
      setFormError("An error occurred while resending the verification code.");
    }
  };

  // useEffect(() => {

  // }, [accessToken]);
  useEffect(() => {
    let interval;
    if (timer > 0) {
      interval = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
    } else if (timer === 0) {
      setShowResendButton(true);
    }
    return () => clearInterval(interval);
  }, [timer]);

  return (
    <div className={styles.wrapper}>
      <Navbar />
      <div style={{ color: "#FFF" }}>Landlord Onbaord page</div>
      <div className={styles.container}>
        {/* Progress Bar */}
        <div className={styles.progressBar}>
          <div
            className={`${styles.step} ${step >= 1 ? styles.active : ""}`}
          ></div>
          <div
            className={`${styles.step} ${step >= 2 ? styles.active : ""}`}
          ></div>
          <div
            className={`${styles.step} ${step >= 3 ? styles.active : ""}`}
          ></div>
          <div
            className={`${styles.step} ${step >= 4 ? styles.active : ""}`}
          ></div>
        </div>

        <div className={styles.formContainer}>
          {/* Email Step */}
          {step === 1 && (
            <div className={styles.formSection}>
              <div className={`${styles.formComponent}`}>
                <TextField
                  id="email"
                  name="email"
                  label="Email"
                  variant="outlined"
                  required
                  type="email"
                  fullWidth
                  value={emailDetails.email}
                  onChange={handleEmailChange}
                />
              </div>
              <div className={styles.formComponent}>
                <div className={styles.formAction}>
                  <Button variant="contained" size="large" onClick={handleNext}>
                    Next
                  </Button>
                </div>
              </div>
            </div>
          )}

          {/* Basic Details Step */}
          {step === 2 && (
            <div className={styles.formSection}>
              <div className={styles.formComponent}>
                <TextField
                  id="firstName"
                  name="firstName"
                  label="First Name"
                  variant="outlined"
                  required
                  type="text"
                  fullWidth
                  value={basicDetails.firstName}
                  onChange={handleBasicChange}
                />
              </div>
              <div
                className={`${styles.formComponent} ${styles.componentType1}`}
              >
                <TextField
                  id="middleName"
                  name="middleName"
                  label="Middle Name"
                  variant="outlined"
                  type="text"
                  fullWidth
                  value={basicDetails.middleName}
                  onChange={handleBasicChange}
                />
                <TextField
                  id="lastName"
                  name="lastName"
                  label="Last Name"
                  variant="outlined"
                  required
                  type="text"
                  fullWidth
                  value={basicDetails.lastName}
                  onChange={handleBasicChange}
                />
              </div>
              <div
                className={`${styles.formComponent} ${styles.componentType2}`}
              >
                {/* <TextField
                  id="email"
                  name="email"
                  label="Email"
                  variant="outlined"
                  required
                  type="email"
                  fullWidth
                  value={basicDetails.email}
                  onChange={handleBasicChange}
                /> */}
                <TextField
                  id="phoneNumber"
                  name="phoneNumber"
                  label="Phone Number"
                  variant="outlined"
                  type="number"
                  inputProps={{ maxLength: 10 }}
                  fullWidth
                  value={basicDetails.phoneNumber}
                  onChange={handleBasicChange}
                />
                {/* <FormControl variant="outlined">
              <InputLabel htmlFor="phoneNumber">Phone Number</InputLabel>
              <Input
                id="phoneNumber"
                name="phoneNumber"
                label="Phone Number"
                variant="outlined"
                value={basicDetails.phoneNumber}
                onChange={handleBasicChange}
                inputComponent={TextMaskCustom}
              />
            </FormControl> */}
              </div>
              <div
                className={`${styles.formComponent} ${styles.componentType3}`}
              >
                <TextField
                  id="screenName"
                  name="screenName"
                  label="Screen Name"
                  variant="outlined"
                  type="text"
                  fullWidth
                  value={basicDetails.screenName}
                  onChange={handleBasicChange}
                />
                <FormControl fullWidth>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      id="dateOfBirth"
                      name="dateOfBirth"
                      label="DOB *"
                      maxDate={eighteenYearsAgo}
                      value={
                        basicDetails.dateOfBirth
                          ? dayjs(basicDetails.dateOfBirth)
                          : null
                      }
                      onChange={handleDOBChange}
                      // renderInput={(params) => <TextField {...params} />}
                    />
                  </LocalizationProvider>
                </FormControl>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">Gender</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="gender"
                    name="gender"
                    value={basicDetails.gender}
                    label="Gender"
                    onChange={handleBasicChange}
                  >
                    <MenuItem value={"Male"}>Male</MenuItem>
                    <MenuItem value={"Female"}>Female</MenuItem>
                    <MenuItem value={"Other"}>Other</MenuItem>
                  </Select>
                </FormControl>
              </div>
              <div className={styles.formComponent}>
                <TextField
                  id="bio"
                  name="bio"
                  label="Bio"
                  multiline
                  rows={4}
                  value={basicDetails.bio}
                  onChange={handleBasicChange}
                />
              </div>
              <div className={styles.formComponent}>
                <div className={styles.formAction}>
                  <Button variant="outlined" size="large" onClick={handleBack}>
                    Back
                  </Button>
                  <Button variant="contained" size="large" onClick={handleNext}>
                    Next
                  </Button>
                </div>
              </div>
            </div>
          )}

          {/* Password Step */}
          {step === 3 && (
            <div className={styles.formSection}>
              <div className={styles.formComponent}>
                <TextField
                  id="password"
                  name="password"
                  label="Password"
                  variant="outlined"
                  required
                  type="password"
                  fullWidth
                  value={passwordDetails.password}
                  onChange={handlePasswordChange}
                />
              </div>
              <div className={styles.formComponent}>
                <TextField
                  id="confirmPassword"
                  name="confirmPassword"
                  label="Confirm Password"
                  variant="outlined"
                  required
                  type="password"
                  fullWidth
                  value={passwordDetails.confirmPassword}
                  onChange={handlePasswordChange}
                />
              </div>
              <div className={styles.formComponent}>
                <div className={styles.formActions}>
                  <Button variant="outlined" size="large" onClick={handleBack}>
                    Back
                  </Button>
                  <Button variant="contained" size="large" onClick={handleNext}>
                    Next
                  </Button>
                </div>
              </div>
            </div>
          )}

          {/* Verification Details Step */}
          {step === 4 && (
            <div className={styles.formSection}>
              <div>Email Verification</div>
              <div
                className={`${styles.formComponent} ${styles.componentType1}`}
              >
                <TextField
                  id="verificationCode"
                  name="verificationCode"
                  label="Verification Code"
                  variant="outlined"
                  type="text"
                  fullWidth
                  required
                  value={verificationDetails.verificationCode}
                  onChange={handleVerificationChange}
                />
                <div>
                  {showResendButton ? (
                    <Button onClick={handleResendCode}>Resend Code</Button>
                  ) : (
                    <div>
                      <div>You can resend code after {timer} seconds</div>
                    </div>
                  )}
                </div>
              </div>

              <div className={styles.formComponent}>
                <div className={styles.formActions}>
                  {/* <Button variant="outlined" size="large" onClick={handleBack}>
                    Back
                  </Button> */}

                  <Button
                    variant="contained"
                    size="large"
                    onClick={handleSubmit}
                  >
                    Submit
                  </Button>
                </div>
              </div>
            </div>
          )}

          <div className={`${styles.formComponent} ${styles.textCenter}`}>
            {formError ? <p style={{ color: "red" }}>{formError}</p> : <></>}
          </div>
        </div>

        <CenteredDialog
          open={openExistingUserModal}
          onClose={handleExistingUserModalClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <CenteredDialogTitle id="alert-dialog-title">
            Email Already Exists
          </CenteredDialogTitle>
          <CenteredDialogContent>
            <DialogContentText id="alert-dialog-description">
              A user account is already registered with the email address:
            </DialogContentText>
            <DialogContentText>
              <strong>{emailDetails.email}</strong>
            </DialogContentText>
            <DialogContentText>
              Would you like to use the same email to open a landlord account?
            </DialogContentText>
          </CenteredDialogContent>
          <CenteredDialogActions>
            <Button
              onClick={handleExistingUserModalClose}
              variant="outlined"
              sx={{ marginRight: 2 }}
            >
              Use Another Email
            </Button>
            <Button onClick={handleLoginRedirect} variant="contained" autoFocus>
              Yes
            </Button>
          </CenteredDialogActions>
        </CenteredDialog>
      </div>
      <Footer />
    </div>
  );
};

export default LandlordOnboard;
